import styled, { css } from 'styled-components'
import { ProductCard } from '@sainsburys-tech/bolt'

export default styled(ProductCard)`
  width: 100%;
  padding: 0;

  ${props =>
    props.isM053 &&
    css`
      :nth-child(n) {
        padding: 0;
        border: 0;
      }
    `}
  ${props =>
    props.isCarousel &&
    css`
      :nth-child(n) {
        padding: 0;
        border: 0;
        margin: inherit;
        max-width: 100%;
      }
    `}

  /* If the CTA button is the only child of the button container, then it should be full width */
  .btn-cta:only-child {
    flex: 1;
    margin-right: 0;
  }
`
